<template>
  <v-dialog v-model="show" max-width="600px" persistent>
    <v-card>
      <v-card-title>
        <v-row>
          <v-col>
            <span class="text-h5 ml-2">
              {{ $t("healthCheck.result.update") }}
            </span>
          </v-col>
          <v-col cols="auto">
            <v-btn size="small" icon variant="text" @click="close">
              <v-icon size="large" class="text-grey-darken-1">mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-subtitle class="ml-2">
        {{ employee | name }}
      </v-card-subtitle>
      <v-card-text>
        <v-container grid-list-md class="pa-2">
          <v-row dense>
            <v-col cols="6">
              <v-textarea
                v-model="result"
                :label="$t('healthCheck.result.decision')"
                variant="underlined"
                auto-grow
                rows="1"
              />
            </v-col>
            <v-col cols="6">
              <v-textarea
                v-model="suggestion"
                :label="$t('healthCheck.result.suggestion')"
                variant="underlined"
                auto-grow
                rows="1"
              />
            </v-col>
            <v-col cols="6">
              <v-menu
                v-model="occurredAtDatePicker"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="$options.filters.date(healthCheckOccurredAt)"
                    :label="$t('healthCheck.result.healthCheckDate')"
                    prepend-inner-icon="event"
                    @click:prepend-inner="occurredAtDatePicker = true"
                    v-on="on"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="healthCheckOccurredAt"
                  first-day-of-week="1"
                  @input="occurredAtDatePicker = false"
                  no-title
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-menu
                v-model="nextHealthCheckDatePicker"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="$options.filters.date(nextHealthCheckDateTime)"
                    :label="$t('healthCheck.result.nextHealthCheckDate')"
                    prepend-inner-icon="event"
                    @click:prepend-inner="nextHealthCheckDatePicker = true"
                    v-on="on"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="nextHealthCheckDateTime"
                  first-day-of-week="1"
                  @input="nextHealthCheckDatePicker = false"
                  no-title
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="close">
          {{ $t("dialog.cancel") }}
        </v-btn>
        <v-btn
          color="primary"
          @click="save"
          text
          :disabled="!result || !nextHealthCheckDateTime"
        >
          {{ $t("dialog.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import EditHealthCheckResultsMutation from "@/graphql/mutation/healthCheck/EditHealthCheckResults.gql";

export default {
  props: {
    employee: {
      type: Object,
    },
    show: {
      type: Boolean,
    },
    latestResult: {
      type: Object,
    },
  },
  data() {
    return {
      result: "",
      suggestion: null,
      nextHealthCheckDateTime: null,
      healthCheckOccurredAt: null,
      localHealthCheck: null,
      occurredAtDatePicker: false,
      nextHealthCheckDatePicker: false,
    };
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.result = this.latestResult.result || "";
        this.suggestion = this.latestResult.suggestion || null;
        this.healthCheckOccurredAt =
          this.latestResult.healthCheckOccurredAt || null;
        this.nextHealthCheckDateTime =
          this.latestResult.nextHealthCheckDateTime || null;
      }
    },
  },
  methods: {
    close() {
      this.$emit("update:show", false);
    },
    save() {
      this.$apollo
        .mutate({
          mutation: EditHealthCheckResultsMutation,
          variables: {
            resultId: this.latestResult.id,
            healthCheckOccurredAt: new Date(
              this.healthCheckOccurredAt
            ).toISOString(),
            result: this.result,
            suggestion: this.suggestion,
            nextHealthCheckDateTime: new Date(
              this.nextHealthCheckDateTime
            ).toISOString(),
          },
        })
        .then(() => {
          this.$emit("results-edited");
          this.close();
        })
        .catch((err) => {
          this.$store.commit("push_global_message", {
            color: "error",
            text: err,
          });
        });
    },
  },
};
</script>

<style></style>
